import { Component, OnInit } from '@angular/core';
import { SettingsService } from '@app/shared/services/settings/settings.service';

@Component({
  standalone: false,
  selector: 'sbnb-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  loading: boolean = true;
  saving: boolean = false;
  fieldsMeta: any;
  data: any;
  saveStatus: number;

  constructor(private settingsService: SettingsService) { }

  ngOnInit() {
    this.settingsService.getNotificationSettings().subscribe((res) => {
      this.fieldsMeta = res.meta?.descriptions;
      this.data = res.data;
      this.loading = false;
    });
  }

  save() {
    this.saveStatus = 1;
    this.saving = true;

    this.settingsService.saveNotificationSettings(this.data).subscribe((res) => {
      if (res.error) {
        this.saveStatus = 1;
      } else {
        this.saving = false;
        this.saveStatus = 2;
        setTimeout(() => {
          this.saveStatus = null;
        }, 2000);
      }
    });
  }
}
